import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.1111 4H4.88889C4.65314 4 4.42705 4.09365 4.26035 4.26035C4.09365 4.42705 4 4.65314 4 4.88889V5.92889C3.99981 6.16348 4.04606 6.39578 4.13607 6.61242C4.22608 6.82905 4.35807 7.02573 4.52444 7.19111L9.69778 12.3644C9.86415 12.5298 9.99614 12.7265 10.0862 12.9431C10.1762 13.1598 10.2224 13.3921 10.2222 13.6267V19.5556C10.2222 19.6381 10.2452 19.719 10.2886 19.7892C10.332 19.8594 10.3941 19.9162 10.4679 19.9531C10.5417 19.99 10.6244 20.0056 10.7066 19.9982C10.7888 19.9908 10.8673 19.9606 10.9333 19.9111L13.0667 18.3111C13.2875 18.1455 13.4667 17.9308 13.5901 17.6839C13.7135 17.4371 13.7778 17.1649 13.7778 16.8889V13.6267C13.7776 13.3921 13.8238 13.1598 13.9138 12.9431C14.0039 12.7265 14.1358 12.5298 14.3022 12.3644L19.4756 7.19111C19.6419 7.02573 19.7739 6.82905 19.8639 6.61242C19.9539 6.39578 20.0002 6.16348 20 5.92889V4.88889C20 4.65314 19.9063 4.42705 19.7396 4.26035C19.573 4.09365 19.3469 4 19.1111 4ZM18.2222 5.92889L15.7067 8.44444H8.29333L5.77778 5.92889V5.77778H18.2222V5.92889Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgFilterOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgFilterOutline;
